<template>
  <div @drag="elementDrag"
       @mousedown="dragMouseDown"
       ref="draggableWindow"
       id="draggableWindow">
    <div id="draggableWindowheader">
      <slot name="header">
        <i class="icon fas fa-arrows-alt"></i>
        Click here to move
      </slot>
    </div>
    <slot name="content">
      <h1>Hello world</h1>testing
    </slot>
  </div>
</template>

<script>
export default {
  name: "DraggableWindow",
  data: () => ({
    pos1: null,
    pos2: null,
    pos3: null,
    pos4: null
  }),
  methods: {
    dragMouseDown (e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      // prepare for mouse up event
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
    },
    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      // set the element's new position:
      this.$refs.draggableWindow.style.top = (this.$refs.draggableWindow.offsetTop - this.pos2) + "px";
      this.$refs.draggableWindow.style.left = (this.$refs.draggableWindow.offsetLeft - this.pos1) + "px";
      this.$refs.draggableWindow.style.right = 'unset'
    },
    closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }
}
</script>

<style scoped lang="scss">
#draggableWindow {
  position: absolute;
  right: 0;
  z-index: 9000;
  background-color: white;
  border: 1px solid var(--primary);
  text-align: center;
}

#draggableWindowheader {
  display: flex;
  padding: 10px;
  cursor: move;
  z-index: 10;
  background-color: var(--primary);
  color: #fff;
}
</style>
